import styled from "styled-components";
import Text from "@streeteasy/design-system/deprecated/Text";

export const Disclaimer = styled(Text).attrs({ type: "disclaimer" })`
  display: inline;
  margin-left: 4px;
`;
